import { AuthenticationService } from "../authenticationService";
import { APIService } from "../apiService";
import { GetPalletLocationsResponse } from "src/types/api/pallets/getPalletLocations";

class PalletLocationAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/pallets/locations");
  }

  async getPalletLocations(): Promise<GetPalletLocationsResponse> {
    return await this.jwtRequest("GET", "");
  }
}

export { PalletLocationAPIService };
